import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

import './Loader.css'

function Loader({ color, size }) {
  return (
      <ScaleLoader color={color} loading={true} size={size} className='loader'/>
  )
}

export default Loader